import React from "react";
import sharedStyles from "../styles/SharedStyles.module.css";
import caveRightLeft from "../assets/cave_right_left.png";

const Room6 = ({ goToRoom9, goToRoom10, goBack }) => {
  return (
    <div className={sharedStyles.centeredContainer}>
      <h1 className={sharedStyles.pageTitle}>Unnamed Chamber</h1>
      <p className={sharedStyles.pageDescription}>
        The walls here are uneven, carved by time and unseen forces.
      </p>

      <div className={sharedStyles.sceneContainer}>
        {/* Room Image */}
        <img
          src={caveRightLeft}
          alt="Cave Room"
          className={sharedStyles.sceneImage}
        />

        {/* Path Buttons */}
        <button
          className={sharedStyles.button}
          style={{ top: "50%", left: "18%", position: "absolute" }}
          onClick={goToRoom9}
        >
          Left
        </button>
        <button
          className={sharedStyles.button}
          style={{ top: "48%", left: "85%", position: "absolute" }}
          onClick={goToRoom10}
        >
          Right
        </button>
      </div>

      {/* Go Back Button */}
      <button className={sharedStyles.backButton} onClick={goBack}>
        ← Go Back
      </button>
    </div>
  );
};

export default Room6;